<template>
  <div id="profile-view" style="min-height: calc(100vh - 50px)">
    <div class="py-4 py-md-5 text-center">
      <h2>{{$t('profile:header')}}</h2>
    </div>
    <b-card style="border-bottom: 1px solid #eee;" title="Card Title" no-body bg-variant="transparent" header-bg-variant="transparent" border-variant="light" body-bg-variant="light">
      <b-card-header header-tag="nav" header-bg-variant="transparent">
        <b-nav id="tabbed-nav" card-header tabs align="center" class="d-none d-md-flex">
          <b-nav-item to="/profile" exact active-class="active">{{ $t('profile:nav-profile-details') }}</b-nav-item>
          <b-nav-item to="/profile/password"  active-class="active">{{ $t('profile:nav-password') }}</b-nav-item>
          <b-nav-item to="/profile/messaging"  active-class="active">{{ $t('profile:nav-messaging-options') }}</b-nav-item>
          <b-nav-item to="/profile/remove"  active-class="active">{{ $t('profile:nav-remove-user-account') }}</b-nav-item>
        </b-nav>

        <b-nav id="tabbed-nav" card-header vertical align="center" class="d-md-none">
          <b-nav-item to="/profile" active-class="active">{{ $t('profile:nav-profile-details') }}</b-nav-item>
          <b-nav-item to="/profile/password"  active-class="active">{{ $t('profile:nav-password') }}</b-nav-item>
          <b-nav-item to="/profile/messaging"  active-class="active">{{ $t('profile:nav-messaging-options') }}</b-nav-item>
          <b-nav-item to="/profile/remove"  active-class="active">{{ $t('profile:nav-remove-user-account') }}</b-nav-item>
        </b-nav>
      </b-card-header>
      <b-card-body class="py-5" border-variant="dark" body-bg-variant="white" style="border-bottom: 1px solid #ddd;">
        <router-view></router-view>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      profileUser: {},
      updateSuccess: false,
      updateFailure: false
    }
  },
  props: ['passwordRecovery'],
  mounted: function () {
    this.profileUser = this.$store.state.user
  },
  methods: {
    updateProfile () {
      this.updateFailure = false
      this.updateSuccess = false
      this.axios.post('/users/' + this.$store.state.user._id, { user: this.profileUser }).then((response) => {
        this.$store.dispatch('updateUser', response.data.user)
        this.updateSuccess = true
      }).catch(() => {
        this.updateFailure = true
      })
    }
  },
  computed: {
    ...mapGetters(['user', 'numberOfPendingQuestions'])
  },
  watch: {
    user (value) {
      this.profileUser = value
    },
    messagingOptions: {
      deep: true,
      handler () {
        this.makeToast()
      }
    }
  }
}
</script>
